import React, { useEffect } from 'react';
import _ from 'lodash';
import axios from 'axios';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { handleApiRequest } from '../../api';

import useApiError from '../../hook/useApiError';
import useGlobalStatus from '../../hook/useGlobalStatus';

import { POSITION } from '../../constants/global';
import { ALERT_TYPE } from '../../constants/alertMsg';
import { ERROR_DOWNLOAD_EXCEL } from '../../constants/alertMsg';

import { formatDate2, formatDate3 } from '../../utils/date';

import theme from '../../theme';

import SliderIndex from '../../components/slider/SliderIndex';
import DateRange from '../../components/date/DateRange';
import PoperButton from '../../components/poper/PoperButton';

import { FilterOutBox } from './frontPageStyle';


const FilterSettings = (props) => {
  const { userQuery, setUserQuery, dateRange, setDateRange, isLoading, setIsLoading, summaryData } = props;
  const { handleApiErrorStatus } = useApiError();
  const { handleAlertMsgSettings } = useGlobalStatus();

  const handleUserQuery = (range) => {
    setUserQuery(range);
  }

  const fetchDownloadUser = () => {
    if (summaryData.total_users === 0) {
      handleAlertMsgSettings(true, { type: ALERT_TYPE.ERROR, msg: ERROR_DOWNLOAD_EXCEL });
      return;
    }

    setIsLoading(true);
    const filterCondition = new URLSearchParams({
      start_date: dateRange.startDate ? formatDate2(dateRange.startDate) : '',
      end_date: dateRange.endDate ? formatDate2(dateRange.endDate) : '',
      min_user_level: userQuery[0] / 100,
      max_user_level: userQuery[1] / 100,
    })

    handleApiRequest('getDownloadCsv', filterCondition)
      .then(res => {
        if (res.status === 200) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = formatDate3(dateRange.startDate) + '-' + formatDate3(dateRange.endDate) + '_使用者清單' + '.csv';
          a.click();
          window.URL.revokeObjectURL(url);
        } else {
          handleApiErrorStatus(res);
        }
        setIsLoading(false);
      })
  }

  return (
    <FilterOutBox>
      <Stack variant="start-center" mr={2} mb={1}>
        <Typography
          variant="h5"
          mr={1}
          color={theme.palette.grey.w600}
          sx={{ display: { xs: 'none', md: 'none', lg: 'block' } }}
        >
          用戶分級
        </Typography>

        <Stack variant="start-start" mt={-2}>
          <SliderIndex
            userQuery={userQuery}
            setUserQuery={setUserQuery}
            handleUserQuery={handleUserQuery}
          />
        </Stack>
      </Stack>

      <Stack>
        <Stack variant="start-center" mr={2} mb={1}>
          <Typography
            variant="h5"
            mr={2}
            color={theme.palette.grey.w600}
            sx={{ display: { xs: 'none', md: 'none', lg: 'block' } }}
          >
            時間
          </Typography>
          <DateRange
            type="white"
            dateRange={dateRange}
            setDateRange={setDateRange}
            anchorHorizontal={POSITION.RIGHT}
          />
        </Stack>

        <Box mb={1}>
          <PoperButton
            iconLoading={isLoading}
            fetchDownloadData={fetchDownloadUser}
          />
        </Box>
      </Stack>
    </FilterOutBox>
  )
}

export default FilterSettings;